export default __webpack_public_path__ + "static/media/ellipse.28880a0f.svg";